exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search{\n    margin-top: 50px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    vertical-align: baseline;\n}\n\n.clear-search {\n    margin-left: 10px;\n}\n\n.search > input {\n    height: 30px;\n    margin: 20px 20px 0 0;\n}\n\n@media (max-width:576px) {\n    .search > input {\n        width: 60%;\n        margin: 0 auto;\n    }\n\n    .App-header > h1 {\n        font-size: 60px;\n        padding-bottom: 10px;\n        opacity: 1;\n    }\n\n    .App-header>h2 {\n        font-size: 32px;\n    }\n    .App-header>h3 {\n        font-size: 20px;\n    }\n    .search {\n        -ms-flex-direction: column;\n            flex-direction: column;\n    }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/Search.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/Search.css
// module chunks = 0